/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { AdminsRequestBuilderNavigationMetadata, AdminsRequestBuilderRequestsMetadata, type AdminsRequestBuilder } from './admins/index.js';
// @ts-ignore
import { AssociateCustomerRequestBuilderRequestsMetadata, type AssociateCustomerRequestBuilder } from './associateCustomer/index.js';
// @ts-ignore
import { AssociationsRequestBuilderRequestsMetadata, type AssociationsRequestBuilder } from './associations/index.js';
// @ts-ignore
import { CustomersRequestBuilderNavigationMetadata, type CustomersRequestBuilder } from './customers/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/users
 */
export interface UsersRequestBuilder extends BaseRequestBuilder<UsersRequestBuilder> {
    /**
     * The admins property
     */
    get admins(): AdminsRequestBuilder;
    /**
     * The associateCustomer property
     */
    get associateCustomer(): AssociateCustomerRequestBuilder;
    /**
     * The associations property
     */
    get associations(): AssociationsRequestBuilder;
    /**
     * The customers property
     */
    get customers(): CustomersRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const UsersRequestBuilderUriTemplate = "{+baseurl}/api/organizations/users";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const UsersRequestBuilderNavigationMetadata: Record<Exclude<keyof UsersRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    admins: {
        requestsMetadata: AdminsRequestBuilderRequestsMetadata,
        navigationMetadata: AdminsRequestBuilderNavigationMetadata,
    },
    associateCustomer: {
        requestsMetadata: AssociateCustomerRequestBuilderRequestsMetadata,
    },
    associations: {
        requestsMetadata: AssociationsRequestBuilderRequestsMetadata,
    },
    customers: {
        navigationMetadata: CustomersRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
